import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="agent-assignment"
export default class extends Controller {
  static targets = [ "current", "editor", "type", "agentAndAgency", "agencyOnly" ]
  connect() {
  }

  change() {
    this.currentTarget.classList.add("hidden");
    this.editorTarget.classList.remove("hidden");

    const dropdown = this.editorTarget.querySelector("select");
    if (dropdown) { dropdown.focus(); }
  }

  agencyOnly() {
    this.typeTarget.value = "agency_only";

    this.agentAndAgencyTarget.classList.add("hidden");
    this.agencyOnlyTarget.classList.remove("hidden");
  }

  agentAndAgency() {
    this.typeTarget.value = "agent_and_agency";

    this.agencyOnlyTarget.classList.add("hidden");
    this.agentAndAgencyTarget.classList.remove("hidden");
  }
}
